export const formNameBuilder = (names: string[]) => names.join('.')
